function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.0526 6.22661C12.7245 5.8735 10.2267 5.93404 7.97014 6.40138C5.7308 6.86516 3.77046 7.72189 2.49743 8.91273C1.19085 10.1349 0.620592 11.7309 1.26275 13.3451C1.85969 14.8456 3.37909 16.0117 5.27622 16.7902C6.93934 17.4726 8.93268 17.8773 10.9998 17.9761V20L14.9998 17.1053L10.9998 14V15.9736C9.16014 15.8763 7.4316 15.5128 6.03547 14.9399C4.3558 14.2507 3.42687 13.3744 3.1211 12.6058C2.86055 11.9509 2.98908 11.1915 3.8637 10.3733C4.77187 9.52378 6.34019 8.7814 8.37575 8.35982C10.3941 7.94181 12.6529 7.88551 14.7527 8.20399C16.8645 8.5243 18.6037 9.19096 19.7153 10.0228C20.8251 10.8533 21.0956 11.6616 20.9705 12.2968C20.8308 13.0058 20.1397 13.8831 18.6236 14.6411C18.1297 14.8881 17.9294 15.4888 18.1764 15.9827C18.4234 16.4767 19.0241 16.677 19.5181 16.43C21.2739 15.5521 22.6189 14.2768 22.9328 12.6834C23.2612 11.0162 22.3745 9.51468 20.9136 8.4215C19.4546 7.32969 17.3686 6.57789 15.0526 6.22661Z",
  fill: "white"
});

var SvgRotate = function SvgRotate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRotate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rotate.7bfe836b.svg";
export { ForwardRef as ReactComponent };